
<template>
  <tr>
    <td class="">{{ product.name }}</td>
    <td class="">{{ product.productOwnerName }}</td>
    <td class="">{{ product.retailerName }}</td>
    <td class="">{{ $n(product.amount, 'currency') }}</td>
    <td class="">{{ product.productSaleDate | dateFormatOrDefault('-') }}</td>
    <td class="">{{ product.contractValidityStart | dateFormatOrDefault('-') }}</td>
    <td class="">{{ product.contractValidityEnd | dateFormatOrDefault('-') }}</td>
  </tr>
</template>
<script>
import { dateFormatOrDefault } from '../../filters/date-format'

export default {
  name: 'TlsProductListItem',
  filters: {
    dateFormatOrDefault
  },
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  methods: {}
}

</script>



// WEBPACK FOOTER //
// src/components/tlsProducts/TlsProductListItem.vue